import React, { useId, useState } from 'react';
import { Plus } from 'lucide-react';
export interface NoteInputProps {
  /** Callback when a note is submitted */
  onSubmit: (note: string) => void;
  /** Placeholder text for the input */
  placeholder?: string;
  /** Optional data-id for component identification */
  'data-id'?: string;
}
/**
 * NoteInput - Ocean Design System
 *
 * A 40px height input field with integrated submit button.
 * Follows Ocean specs: ocean border, focus ring, primary action button.
 * Supports Enter key submission.
 */
export function NoteInput({
  onSubmit,
  placeholder = 'Add a note...',
  'data-id': dataId
}: NoteInputProps) {
  const [value, setValue] = useState('');
  // Unique per instance, since a page can show more than one note input
  const inputId = useId();
  const handleSubmit = () => {
    if (value.trim()) {
      onSubmit(value.trim());
      setValue('');
    }
  };
  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };
  return <div className="relative" data-id="element-4906" data-mp="2v8ovo6katae6">
      <label htmlFor={inputId} className="sr-only" data-id="element-4907" data-mp="2q8alahv85ocz">
        Add a note
      </label>
      <input id={inputId} type="text" placeholder={placeholder} className="w-full h-[40px] pl-4 pr-10 py-2 border border-[#CBD5E1] rounded-md text-[14px] bg-white focus:border-[#0EA5E9] focus:shadow-[0_0_0_3px_rgba(14,165,233,0.2)] outline-none transition-all duration-200" value={value} onChange={e => setValue(e.target.value)} onKeyPress={handleKeyPress} data-id="element-4908" data-mp="2qadj3o2mcls9" />
      <button onClick={handleSubmit} disabled={!value.trim()} className="absolute right-2 top-1/2 -translate-y-1/2 text-[#0EA5E9] hover:text-[#0284C7] disabled:text-[#94A3B8] disabled:cursor-not-allowed transition-all duration-200" aria-label="Add note" data-id="element-4909" data-mp="38ztr0wgmvgip">
        <Plus size={18} aria-hidden="true" data-id="element-4910" data-mp="iyvk2260yen" />
      </button>
    </div>;
}